import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, Injector, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { provideNgxMask } from 'ngx-mask';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import { routes } from './app-routing.module';
import { NavbarComponent } from './components/navbar/navbar.component';
import { SearchByIdComponent } from './components/search-by-id/search-by-id.component';
import { SearchByIdModalComponent } from './components/search-by-id-modal/search-by-id-modal.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { PermissionEnum } from './models/permission.enum';
import { ConfirmModalModule } from './modules/confirm-modal/confirm-modal.module';
import { InactiveSessionsDialogComponent } from './modules/inactive-sessions/components/inactive-sessions-dialog.component';
import { IncludesActiveInLinksPipe } from './pipes/includes-active-in-links.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { AuthService } from './services/auth.service';

@NgModule({
  declarations: [],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    RouterModule.forRoot(routes),
    MatSidenavModule,
    MatProgressBarModule,
    MatBadgeModule,
    MatMenuModule,
    MatListModule,
    MatCardModule,
    ConfirmModalModule,
    MatDialogModule,
    FormsModule,
    MatInputModule,
    NgxPermissionsModule.forRoot(),
    MatExpansionModule,
    ToastrModule.forRoot(),
    AppComponent,
    NavbarComponent,
    SearchByIdComponent,
    SearchByIdModalComponent,
    IncludesActiveInLinksPipe,
    SafePipe,
    InactiveSessionsDialogComponent,
  ],
  providers: [
    provideNgxMask({
      validation: false,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (injector: Injector) => async () => {
        const authService = injector.get(AuthService);
        const ngxPermissionsService = injector.get(NgxPermissionsService);
        try {
          await authService.loadSession().toPromise();
        } catch (e) {
          return;
        }
        const user = authService.authUser.value!;
        const permissionsNames = user.permissions.map((p) => PermissionEnum[p]);
        ngxPermissionsService.loadPermissions(permissionsNames);
      },
      deps: [Injector],
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
